/**
 * Utility function to get the data from a firebase return
 * @param {object} snapshot the return from a db query from firestore
 * @returns {object} the actual data from the collection
 */
export default function parseSnapshot (snapshot) {
  let output = {}
  snapshot.forEach(doc => {
    if (doc.exists) {
      const data = doc.data()
      if (!data.deleted) {
        output[doc.id] = data
      }
    }
  })
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/parseSnapshot.js